import React from 'react'
import { Panel, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { chain, keys, pick, uniq, keyBy, zipObject } from 'lodash'
import { createSelector } from 'reselect'

import Button from '../components/Button.jsx'
import { getAllActivities, getAllCities } from '../selectors'
import FilesSelector from '../lib/FilesSelector.jsx'
import { getTransportationLabel } from '../lib/text.js'

const getTransportName = item => (
  `${getTransportationLabel(item.transport.means)} de ${item.transport.originCity} a ${item.transport.to}`
)

const ActivitiesModal = ({ transports, activities, onCancel, onSelect }) => (
  <Modal show onHide={() => onCancel()}>
    <Modal.Header>
      <Modal.Title>
        Añadir entradas para la actividad...
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ul>
        {
          transports
            .map(item => (
              <li key={item.key}>
                <a onClick={() => onSelect(item.key)}>
                  {getTransportName(item)}
                </a>
              </li>
            ))
        }
        {
          uniq(activities)
            .map(activity => (
              <li key={activity._id}>
                <a onClick={() => onSelect(activity._id)}>
                  {activity.name}
                </a>
              </li>
            ))
        }
        {
          activities.length == 0 && transports.length == 0 && "No hay nada más que añadir."
        }
      </ul>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onCancel}>Cerrar</Button>
    </Modal.Footer>
  </Modal>
)

class TicketsPage extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = {
      addingToCity: null
    }
  }

  onStartAdd(addingToCity) { this.setState({ addingToCity }) }

  onCancelAdd() { this.setState({ addingToCity: null }) }

  render() {
    const {
      Activities, thingsWithTicketAlready, transportsPerCity, Cities,
      trip, activitiesPerCity, routeCities, onChange
    } = this.props

    return (
      <Panel className="main">
        <Panel.Body>

          {
            this.state.addingToCity && (
              <ActivitiesModal
                activities={
                  (activitiesPerCity[this.state.addingToCity] || [])
                    .filter(a => !thingsWithTicketAlready.has(a)).map(id => Activities[id])
                }
                transports={
                  (transportsPerCity[this.state.addingToCity] || [])
                    .filter(a => !thingsWithTicketAlready.has(a))
                }
                onCancel={() => this.onCancelAdd()}
                onSelect={activityId => onChange({ ...trip.tickets, [activityId]: null })}
              />
            )
          }

          <div style={{ marginLeft: 10, maxWidth: 700 }}>
            {
              routeCities.map(cityId => {
                const activities = activitiesPerCity[cityId] || []
                const transportKeys = (transportsPerCity[cityId] || []).map(item => item.key)
                const transportsDict = keyBy(transportsPerCity[cityId], "key")

                const files = {
                  ...(zipObject(activities, activities.map(() => null))),
                  ...(zipObject(transportKeys, transportKeys.map(() => null))),
                  ...pick(trip.tickets, [...activities, ...transportKeys])
                }

                return (
                  <div key={cityId}>
                    <FilesSelector
                      value={files}
                      onChange={obj => onChange({ ...trip.tickets, ...obj })}
                      includeNotes
                      fileNotes={trip.ticketFileNotes || {}}
                      onNotesChange={ticketFileNotes => onChange({ ticketFileNotes })}
                      labels={key => (Activities[key] ? Activities[key].name : getTransportName(transportsDict[key]))}
                      extensions={["pdf", "jpeg", "jpg", "png"]}
                      title={
                        <div>
                          {`Entradas de ${Cities[cityId].name}:`}
                        </div>
                      }
                    />
                  </div>
                )
              })
            }
          </div>

        </Panel.Body>
      </Panel>
    )
  }
}

// this produces an object with { [city]: array of activities in this route in this city }
const getRouteActivitiesPerCity = createSelector(
  [ getAllActivities, getAllCities, (s, op) => op.route.agenda ],
  (Activities, CitiesIgnored, agenda) => (
    agenda
      .filter(item => item.type == "activity")
      .map(item => Activities[item.id])
      .reduce((dict, { city, _id }) => ({
        ...dict,
        [city]: (dict[city] ? [...dict[city], _id] : [_id]) // prolly unneeded check, but fails without it (?)
      }), {})
  )
)

const getRouteCities2 = createSelector(
  [ getAllActivities, (state, ownProps) => ownProps.route.agenda ],
  (Activities, agenda) => (
    chain(agenda)
      .map(item => (
        (item.type == "activity" && Activities[item.id].city)
        || (item.type == "city" && item.transport && item.transport.originCity)
      ))
      .compact()
      .uniq()
      .value()
  )
)

//
const getTransportsPerOriginCity = agenda => (
  agenda
    .filter(x => x.type == "city" && x.transport && x.transport.originCity)
    .reduce((acc, item) => ({
      ...acc,
      [item.transport.originCity]: (
        acc[item.transport.originCity] ? [...acc[item.transport.originCity], item]  : [item]
      )
    }), {})
)

const mapStateToProps = (state, ownProps) => ({
  routeCities: getRouteCities2(state, ownProps),
  activitiesPerCity: getRouteActivitiesPerCity(state, ownProps),
  transportsPerCity: getTransportsPerOriginCity(ownProps.route.agenda),
  thingsWithTicketAlready: new Set(keys(ownProps.trip.tickets))
})

export default connect(mapStateToProps)(TicketsPage)
